module.exports = __webpack_public_path__ + "img/gem.84afb062.png";